module.exports = __webpack_public_path__ + "img/top-left.dfa5f39f.jpg";